import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { langPrefixURL } from 'utils/link-generator-utils';

export default class LocalizedLink extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { props } = this;

    const to =
      typeof props.to === 'string'
        ? langPrefixURL(props.to)
        : {
            ...props.to,
            pathname: langPrefixURL(props.to.pathname)
          };
    return <Link {...props} to={to} />;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/LocalizedLink/LocalizedLink.js